module.exports = __webpack_public_path__ + "static/img/cgal11.b713e40.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/cgal11.png
// module id = RZvb
// module chunks = 1